module.exports = __webpack_public_path__ + "img/more.02d3e93c.svg";